import { RenameStatus, RestoreDefaultStatuses, SetStatusColor } from '..';

export const createChangeStatusColorCommand = async (storymapId: string, key: number, color: string) => {
    const cmd = new SetStatusColor(storymapId, key, color);

    return cmd;
};

export const createChangeStatusNameCommand = async (storymapId: string, key: number, name: string) => {
    const cmd = new RenameStatus(storymapId, key, name);

    return cmd;
};

export const createRestoreDefaultStatusesCommand = async (storymapId: string) => {
    const cmd = new RestoreDefaultStatuses(storymapId);

    return cmd;
};
